import { render, staticRenderFns } from "./SkeletonActivities.vue?vue&type=template&id=473e0a40&"
import script from "./SkeletonActivities.vue?vue&type=script&lang=js&"
export * from "./SkeletonActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SkeletonActivities.vue"
export default component.exports